<template>
    <div>
        <p class="timeline-talks">{{ message }}</p>
        <div class="timeline-component">
            <p v-if="details.purposeOfProcessing" ><strong>Purpose of Processing : </strong>{{details.purposeOfProcessing}}</p>
            <p v-if="details.userId" ><strong> Action By : </strong>{{details.user.firstName}} {{details.user.lastName}} ({{details.user.role.title}})</p>
            <p v-else ><strong> Action By : </strong>Idenfo System</p>
            <p v-if="details.legalBasisForProcessing" ><strong>Legal Basis for Processing : </strong>{{details.legalBasisForProcessing}}</p>
            <p v-if="details.retentionPeriod" ><strong>Retention Period : </strong>{{details.retentionPeriod}}</p>
        </div>
    </div>
</template>

<script>
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: ['details'],
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */

    data() {
        return {}
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */

    computed: {
        message() {
            return 'Cancelled KYC Review process'
        },
    },
}
</script>
